/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as NavmapRouteImport } from "./routes/navmap/route";
import { Route as IndexImport } from "./routes/index";
import { Route as NavmapIndexImport } from "./routes/navmap/index";
import { Route as LoadoutsIndexImport } from "./routes/loadouts/index";
import { Route as NavmapSystemImport } from "./routes/navmap/$system";

// Create/Update Routes

const NavmapRouteRoute = NavmapRouteImport.update({
  id: "/navmap",
  path: "/navmap",
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const NavmapIndexRoute = NavmapIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => NavmapRouteRoute,
} as any);

const LoadoutsIndexRoute = LoadoutsIndexImport.update({
  id: "/loadouts/",
  path: "/loadouts/",
  getParentRoute: () => rootRoute,
} as any);

const NavmapSystemRoute = NavmapSystemImport.update({
  id: "/$system",
  path: "/$system",
  getParentRoute: () => NavmapRouteRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    "/navmap": {
      id: "/navmap";
      path: "/navmap";
      fullPath: "/navmap";
      preLoaderRoute: typeof NavmapRouteImport;
      parentRoute: typeof rootRoute;
    };
    "/navmap/$system": {
      id: "/navmap/$system";
      path: "/$system";
      fullPath: "/navmap/$system";
      preLoaderRoute: typeof NavmapSystemImport;
      parentRoute: typeof NavmapRouteImport;
    };
    "/loadouts/": {
      id: "/loadouts/";
      path: "/loadouts";
      fullPath: "/loadouts";
      preLoaderRoute: typeof LoadoutsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/navmap/": {
      id: "/navmap/";
      path: "/";
      fullPath: "/navmap/";
      preLoaderRoute: typeof NavmapIndexImport;
      parentRoute: typeof NavmapRouteImport;
    };
  }
}

// Create and export the route tree

interface NavmapRouteRouteChildren {
  NavmapSystemRoute: typeof NavmapSystemRoute;
  NavmapIndexRoute: typeof NavmapIndexRoute;
}

const NavmapRouteRouteChildren: NavmapRouteRouteChildren = {
  NavmapSystemRoute: NavmapSystemRoute,
  NavmapIndexRoute: NavmapIndexRoute,
};

const NavmapRouteRouteWithChildren = NavmapRouteRoute._addFileChildren(
  NavmapRouteRouteChildren,
);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/navmap": typeof NavmapRouteRouteWithChildren;
  "/navmap/$system": typeof NavmapSystemRoute;
  "/loadouts": typeof LoadoutsIndexRoute;
  "/navmap/": typeof NavmapIndexRoute;
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/navmap/$system": typeof NavmapSystemRoute;
  "/loadouts": typeof LoadoutsIndexRoute;
  "/navmap": typeof NavmapIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/": typeof IndexRoute;
  "/navmap": typeof NavmapRouteRouteWithChildren;
  "/navmap/$system": typeof NavmapSystemRoute;
  "/loadouts/": typeof LoadoutsIndexRoute;
  "/navmap/": typeof NavmapIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: "/" | "/navmap" | "/navmap/$system" | "/loadouts" | "/navmap/";
  fileRoutesByTo: FileRoutesByTo;
  to: "/" | "/navmap/$system" | "/loadouts" | "/navmap";
  id:
    | "__root__"
    | "/"
    | "/navmap"
    | "/navmap/$system"
    | "/loadouts/"
    | "/navmap/";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  NavmapRouteRoute: typeof NavmapRouteRouteWithChildren;
  LoadoutsIndexRoute: typeof LoadoutsIndexRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  NavmapRouteRoute: NavmapRouteRouteWithChildren,
  LoadoutsIndexRoute: LoadoutsIndexRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/navmap",
        "/loadouts/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/navmap": {
      "filePath": "navmap/route.tsx",
      "children": [
        "/navmap/$system",
        "/navmap/"
      ]
    },
    "/navmap/$system": {
      "filePath": "navmap/$system.tsx",
      "parent": "/navmap"
    },
    "/loadouts/": {
      "filePath": "loadouts/index.tsx"
    },
    "/navmap/": {
      "filePath": "navmap/index.tsx",
      "parent": "/navmap"
    }
  }
}
ROUTE_MANIFEST_END */
